module.exports = __webpack_public_path__ + "static/img/brees-2017-slide-2.6e33b73.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2017-slide-2.jpg
// module id = +hhH
// module chunks = 1